<script lang="ts">
  import EggMark from './EggMark.svelte';
</script>

<div class="splash" aria-busy="true">
  <EggMark size={40} />
  <span class="eyebrow">Loading…</span>
</div>

<style>
  .splash {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 100dvh;
    color: var(--ink-faint);
  }
</style>
